import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { PreviewImageComponent } from "./preview-image.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [PreviewImageComponent],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: ":id",
        component: PreviewImageComponent
      },
      {
        path: ":id/content",
        component: PreviewImageComponent
      },
      {
        path: ":id/thumbnail/:size",
        component: PreviewImageComponent
      }
    ])
  ]
})
export class PreviewImageModule {}
